module.exports = __webpack_public_path__ + "static/media/vlinder-logo.e9047422.png";